<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'最强蜗牛三周年年度报告'"></div>
    <div class="main">
      <div class="title"></div>
      <div class="detail-btn" @click="isShowDetailDialog"></div>
      <div class="share-start-btn" @click="shareShow = true"></div>

      <!-- 分享弹窗 -->
      <div class="help-share-wrap popup_wrap" v-show="shareShow">
        <div class="share-wrap1" @click="shareShow = false">
          <div class="help-share-box popup_wrap-box" v-show="shareShow">
            <div
              class="close-bg"
              v-show="shareShow"
              @click="shareShow = false"
            ></div>
            <img :src="shareImg" alt="分享图片" />
          </div>
        </div>
      </div>
      <Dialog ref="dialogRef"></Dialog>

      <!-- 分享相关DOM -->
      <div class="share-box-1" ref="imageDom">
        <img
          src="https://download4.qcplay.com/snail/triennial/mobile/share.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { generateCanvasImage } from "@/utils/share";
import Dialog from "../components/dialog.vue";

export default {
  components: { Dialog },
  data() {
    return {
      // 分享弹窗
      shareShow: false,
      shareImg: ""
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initShareData();
    });
  },
  computed: {},
  watch: {},
  methods: {
    // 打开活动详情弹窗
    isShowDetailDialog() {
      this.$refs.dialogRef.isShowActivityDetail = true;
    },
    // 初始化分享信息
    initShareData() {
      try {
        this.generateShareImage();
      } catch (err) {
        // 错误信息
        console.log("err", err);
      }
    },
    // 分享图片设置
    generateShareImage() {
      generateCanvasImage(this.$refs.imageDom)
        .then(canvas => {
          this.shareImg = canvas.toDataURL("image/png"); // 可将 canvas 转为 base64 格式
          console.log("success: 图片生成成功", canvas);
        })
        .catch(err => {
          console.log("err: 图片生成失败", err.message);
        });
    }
  }
};
</script>

<style lang="less" scope>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/triennial/game/index.vue